import { render, staticRenderFns } from "./TipoCambio.vue?vue&type=template&id=5d51eb0e"
import script from "./TipoCambio.vue?vue&type=script&lang=ts"
export * from "./TipoCambio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports